import React from 'react';
import {
    removeTrailingZeros,
    setPriceToZeroIfFreebies,
} from '@gumtree/ui-library/src/utils/currency-service';
import { TextBtn } from '@gumtree/create-order/src/page/create-order-page.style';
import { L2CategoryId } from '@gumtree/shared/src/util/category-mapping';
import { PriceContainer, ItemPrice, ExtraPrice, PriceDivider } from './index.style';

const RenderPriceBlock: React.FC<Props> = ({
    price,
    deliveryFromPrice,
    buyerProtectionPrice,
    l2CategoryId,
    isStickyHeader,
    setIsBuyerProtectionOpen,
}) => {
    const renderedPrice = removeTrailingZeros(setPriceToZeroIfFreebies(price, l2CategoryId));

    return (
        <PriceContainer>
            <ItemPrice>{renderedPrice}</ItemPrice>
            <ExtraPrice style={{ fontWeight: isStickyHeader ? 600 : 330 }}>
                {deliveryFromPrice}
                <PriceDivider>|</PriceDivider>
                {isStickyHeader ? (
                    'Buyer Protection '
                ) : (
                    <TextBtn
                        type="button"
                        style={{ marginRight: -3 }}
                        onClick={() => setIsBuyerProtectionOpen?.(true)}
                    >
                        Buyer Protection
                    </TextBtn>
                )}

                {buyerProtectionPrice}
            </ExtraPrice>
        </PriceContainer>
    );
};

interface Props {
    price: string;
    deliveryFromPrice: string | undefined;
    buyerProtectionPrice: string | undefined;
    l2CategoryId: L2CategoryId;
    isStickyHeader?: boolean;
    setIsBuyerProtectionOpen?: (isOpen: boolean) => void;
}

export default RenderPriceBlock;
